<template>
    <div>
        <b-modal
                centered
                scrollable
                size="xl"
                ref='form'
                title="Editeaza/Creeaza"
                ok-variant="success"
                @ok="onOk"
                @hide="clear"
                @cancel="clear"
                id="person-modal"
        >
            <form class="compact">
                <div class="text-danger" v-show="hasError()">
                    <strong>{{getError()}}</strong>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                                <div class="text-danger">
                                    {{getError('name')}}
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="text-danger">
                                    {{getError('organization')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <label for="name" class="col-1" :class="{'text-danger': hasError('name')}">Nume</label>
                    <div class="col-5">
                        <input
                                type="text"
                                class="form-control form-control-sm"
                                :class="{'border-danger': hasError('name')}"
                                id="name"
                                v-model="person.name"
                        >
                    </div>
                    <label for="organization" class="col-1" :class="{'text-danger': hasError('organization')}">Organizatie</label>
                    <div class="col-5">
                        <input
                                type="text"
                                class="form-control form-control-sm"
                                :class="{'border-danger': hasError('organization')}"
                                id="organization"
                                v-model="person.organization"
                        >
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <div class="text-danger" v-if="hasError('comment')">
                            {{getError('comment')}}
                        </div>
                    </div>
                    <label
                            for="comment"
                            class="col-1"
                            :class="{'text-danger': hasError('comment')}"
                    >
                        Comentariu
                    </label>
                    <div class="col-11">
                        <textarea
                                class="form-control"
                                id="comment"
                                rows="2"
                                v-model="person.comment"
                                :class="{'text-danger': hasError('comment')}"
                        ></textarea>
                    </div>
                </div>
            </form>
            <div class="col-12 mb-3 mt-3 subscriptions-heading bg-light pt-2 pb-2">
                <div class="row">
                    <div class="col-10">
                        <strong>Modalitati de contact/Subscriptii</strong>
                    </div>
                    <div class="col-2 text-right">
                        <button class="btn btn-primary btn-sm" @click="addContact">Adauga</button>
                    </div>
                </div>
            </div>
            <EditableContact
                    v-for="(contact,index) in person.contacts"
                    :index="index"
                    :key="contact.id"
                    :id="contact.id"
                    :handler="contact.handler"
                    :is_active="contact.is_active"
                    :priority="contact.priority"
                    :lists="contact.lists"
                    @deleted="deleteContact"
                    :errors="((errors.errors || {}).contacts || {})[index] || {}"
                    ref="contacts"
            />
        </b-modal>
    </div>
</template>

<script>
    import EditableContact from './EditableContact'
    import {mapActions, mapGetters} from 'vuex'
    import * as types from '../store/types'
    import ErrorPrinter from '../mixins/ErrorPrinter'

    export default {
        mixins: [ErrorPrinter],
        components: {
            EditableContact
        },
        props: {
            id: {
                type: Number,
                required: false
            }
        },
        data: () => {
            return {
                person: {
                    id: null,
                    index: null,
                    name: null,
                    organization: null,
                    comment: null,
                    contacts: [],
                },
                closing: true,
                resolve: null,
                reject: null,
                updatedContacts: [],
                errors: {}
            }
        },
        computed: {
            ... mapGetters('persons', ['getPerson'])
        },
        methods: {
            ... mapActions('persons', [types.PERSONS_UPDATE_PERSON]),

            onOk(bvEvent){
                this.closing = false
                bvEvent.preventDefault()
                this.save()
                .then(res => {
                    console.log('should close modal')
                    this.closing = true
                    this.$refs.form.hide()
                })
                .catch(err => {
                    this.closing = false
                    console.log('caught error from store')
                    this.errors = err
                })
            },

            clear(){
                if(!this.closing){
                    return
                }
                this.person = {
                    contacts: []
                }
                this.errors = {}
            },

            show(personId){
                console.log('showing editable person', personId)
                this.person = this.getPerson(personId) || {contacts: []}
                console.log(this.person)
                this.errors = {}
                this.$refs.form.show()
            },

            addContact(){
                this.save().then(resp => {
                    this.person.contacts.splice(0, 0,{
                        name: null,
                        handler: null,
                        priority: 1000,
                        lists: []
                    })
                })
                .catch(err => {
                    console.log('api error')
                    this.errors = err
                })
            },
            deleteContact(contact){
                this.person.contacts = this.person.contacts.filter(
                    crt => crt.id !== contact.id
                )
                this.errors = {}
            },

            save(){
                return this[types.PERSONS_UPDATE_PERSON]({
                    id: this.person.id,
                    name: this.person.name,
                    organization: this.person.organization,
                    comment: this.person.comment,
                    contacts: (this.$refs.contacts || [])
                        .sort((a, b) => {
                            if(a.$props.index < b.$props.index){
                                return -1
                            }
                            else if(a.$props.index === b.$props.index){
                                return 0
                            }
                            return 1
                        }).map(contact => contact.$data.contact)
                })
                .then(res => {
                    console.log(res)
                    this.person = res
                    // this.person.contacts = this.reindex(this.person.contacts)
                    this.errors = {}
                })
                .catch(err => {
                    console.log(err)
                    this.errors = err
                    return Promise.reject(err)
                })
            },
        }
    }
</script>

<style scoped>

</style>